module.exports = __webpack_public_path__ + "img/support.128b415c.svg";